module.exports = __webpack_public_path__ + "assets/img/star-gray.webp?35eea1bd9629d138fbeed162b3755111";